import { render } from "./PrivacyV20260905.vue?vue&type=template&id=3f37e869&scoped=true"
const script = {}

import "./PrivacyV20260905.vue?vue&type=style&index=0&id=3f37e869&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f37e869"]])

export default __exports__